import './App.css';
import DocGpt from "./pages/DocGpt";
import WebsiteGpt from "./pages/WebsiteGpt";

import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="docgpt" element={<DocGpt />}/>
          <Route path="websitegpt" element={<WebsiteGpt />} />
          <Route path="*" element={<DocGpt />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
